var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFinalWwFulllogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 28,
    viewBox: "0 0 170 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Final - WW Full logo (1) 1",
    clipPath: "url(#clip0_3427_243)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M51.6936 8.66708C52.0116 8.66708 52.3594 8.68404 52.7368 8.71797C53.0648 8.74492 53.391 8.79023 53.7139 8.85365L53.3374 12.5738C53.0481 12.498 52.753 12.4451 52.4552 12.4155C52.1452 12.3782 51.8334 12.3584 51.5212 12.3561C50.8213 12.3534 50.1266 12.473 49.4693 12.7095C48.8275 12.9403 48.2406 13.2982 47.7451 13.7611C47.2267 14.2507 46.8235 14.846 46.564 15.5052C46.2646 16.2793 46.1192 17.1027 46.1358 17.9307V27.6635H42.0723V9.02044H45.2334L45.788 12.3109H45.9748C46.355 11.6436 46.828 11.0319 47.3801 10.4932C47.9369 9.94318 48.5889 9.49518 49.3055 9.17026C50.0542 8.83178 50.8696 8.65997 51.6936 8.66708Z",
    fill: "#68297B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M59.2601 1.88265C59.8332 1.86913 60.3951 2.03984 60.8607 2.36886C61.3119 2.69678 61.5361 3.2565 61.5361 4.06498C61.5361 4.87346 61.3119 5.41339 60.8607 5.76109C60.3884 6.08837 59.8248 6.26403 59.2471 6.26403C58.6694 6.26403 58.1058 6.08837 57.6335 5.76109C57.189 5.42564 56.9668 4.86027 56.9668 4.06498C56.9668 3.2678 57.1881 2.70809 57.6335 2.36886C58.1067 2.03545 58.6783 1.86458 59.2601 1.88265ZM61.2458 9.02045V27.6777H57.2053V9.02045H61.2458Z",
    fill: "#68297B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M74.0652 24.8C74.5879 24.8001 75.1094 24.7518 75.6228 24.6558C76.0976 24.5716 76.5661 24.4564 77.0252 24.311V27.3102C76.4699 27.5329 75.8918 27.6959 75.301 27.7965C74.5727 27.9339 73.8326 28.0021 73.091 28C72.1009 28.015 71.1178 27.8343 70.2 27.4686C69.3301 27.1046 68.6116 26.4607 68.1626 25.6424C67.6606 24.7774 67.4096 23.5816 67.4096 22.0551V12.0537H64.8232V10.2841L67.5964 8.87067L68.8925 4.87915H71.4243V9.02049H76.8528V12.0537H71.43V22.0042C71.43 22.9465 71.6704 23.6485 72.1513 24.1102C72.4062 24.3467 72.7073 24.5298 73.0363 24.6484C73.3653 24.767 73.7154 24.8186 74.0652 24.8Z",
    fill: "#68297B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M88.4136 8.66716C89.93 8.62514 91.4305 8.98025 92.7616 9.69613C93.9644 10.3733 94.9356 11.3867 95.552 12.6078C96.2364 14.0182 96.5703 15.5685 96.5262 17.1308V19.2509H83.8817C83.9276 21.0601 84.421 22.4528 85.3616 23.429C86.3023 24.4052 87.6233 24.8933 89.3246 24.8933C90.4218 24.9052 91.5166 24.7894 92.5863 24.5484C93.6114 24.2965 94.6116 23.955 95.575 23.5279V26.7279C94.6515 27.1577 93.6804 27.4802 92.6811 27.6891C91.5191 27.9063 90.3377 28.0077 89.155 27.9915C87.4547 28.0266 85.7703 27.6632 84.2409 26.9315C82.8341 26.2292 81.6812 25.1178 80.9389 23.7484C80.1515 22.3331 79.7578 20.5701 79.7578 18.4594C79.7578 16.3487 80.1151 14.5819 80.8297 13.159C81.4781 11.7746 82.533 10.6128 83.8587 9.82334C85.2407 9.03499 86.8163 8.63506 88.4136 8.66716ZM88.4136 11.6495C87.8424 11.6288 87.2734 11.7275 86.7438 11.9389C86.2143 12.1504 85.7364 12.4699 85.3415 12.8763C84.557 13.682 84.1001 14.8551 83.9621 16.4269H92.5834C92.5892 15.5833 92.4302 14.7464 92.115 13.9619C91.839 13.2778 91.3655 12.6881 90.7528 12.2657C90.0559 11.8289 89.2392 11.6137 88.4136 11.6495Z",
    fill: "#68297B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M116.557 27.6466L114.16 18.9908C114.045 18.564 113.91 18.0466 113.749 17.4417C113.588 16.8368 113.43 16.2092 113.269 15.5647C113.109 14.9201 112.965 14.318 112.836 13.7611C112.706 13.2042 112.603 12.7774 112.534 12.4749H112.399C112.341 12.7774 112.249 13.2071 112.111 13.7611C111.973 14.3152 111.844 14.9201 111.683 15.5732C111.522 16.2262 111.367 16.8565 111.215 17.4756C111.062 18.0947 110.927 18.6064 110.795 19.0417L108.278 27.6466H103.872L98.5645 9.00354H102.639L105.102 18.2671C105.261 18.8947 105.418 19.5741 105.574 20.3053C105.729 21.0365 105.863 21.7319 105.976 22.3915C106.088 23.0558 106.174 23.5986 106.232 24.0254H106.37C106.416 23.723 106.476 23.3385 106.556 22.8721C106.637 22.4057 106.729 21.9166 106.844 21.4078C106.959 20.8989 107.048 20.4127 107.151 19.9576C107.255 19.5025 107.35 19.1378 107.439 18.8551L110.344 9.00354H114.744L117.534 18.8551C117.657 19.281 117.794 19.8172 117.945 20.4636C118.096 21.11 118.231 21.7555 118.347 22.4C118.465 23.0474 118.543 23.5816 118.577 24.0085H118.715C118.761 23.6269 118.842 23.1067 118.962 22.4509C119.083 21.7951 119.221 21.094 119.382 20.3449C119.543 19.5958 119.707 18.906 119.879 18.2671L122.394 9.00354H126.4L121.06 27.6608L116.557 27.6466Z",
    fill: "#68297B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M131.69 1.88271C132.263 1.86878 132.825 2.03953 133.29 2.36893C133.742 2.69685 133.966 3.25656 133.966 4.06504C133.966 4.87352 133.742 5.41345 133.29 5.76116C132.818 6.08843 132.255 6.2641 131.677 6.2641C131.099 6.2641 130.536 6.08843 130.063 5.76116C129.617 5.4257 129.395 4.86033 129.396 4.06504C129.396 3.26787 129.618 2.70815 130.063 2.36893C130.537 2.0359 131.108 1.86507 131.69 1.88271ZM133.676 9.02052V27.6778H129.635V9.02052H133.676Z",
    fill: "#68297B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M152.114 27.6636H137.699V25.2212L147.286 12.0876H138.3V9.02051H151.841V11.7456L142.461 24.6163H152.117L152.114 27.6636Z",
    fill: "#68297B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M163.391 17.583C163.391 17.5547 163.46 17.2692 163.523 16.9498C164.072 14.2219 164.672 13.0459 165.948 12.2939C166.658 11.8699 167.787 11.5137 169.354 11.2141C169.681 11.1547 169.969 11.0925 169.997 11.084C169.799 11.0092 169.593 10.958 169.382 10.9314C167.083 10.4791 165.977 10.0296 165.19 9.2579C164.451 8.52857 163.96 7.33846 163.543 5.27769C163.474 4.93281 163.405 4.61055 163.396 4.56249C163.388 4.51444 163.319 4.72928 163.221 5.21267C162.75 7.47415 162.336 8.48334 161.543 9.26355C160.75 10.0438 159.761 10.4395 157.445 10.9144C157.213 10.9489 156.984 11.0057 156.764 11.084C156.792 11.084 157.114 11.1604 157.479 11.231C159.591 11.6438 160.787 12.1215 161.543 12.865C162.299 13.6084 162.747 14.6572 163.201 16.8226C163.244 17.0804 163.308 17.3346 163.391 17.583Z",
    fill: "url(#paint0_linear_3427_243)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M156.097 8.22328C156.488 6.41409 156.692 5.88264 157.195 5.35402C157.698 4.8254 158.304 4.58794 159.781 4.27982C160.069 4.22045 160.301 4.16957 160.307 4.16109C160.15 4.11738 159.991 4.08246 159.83 4.0565C158.517 3.80208 157.755 3.49113 157.27 3.03883C156.784 2.58653 156.491 1.90809 156.221 0.607733C156.152 0.279818 156.091 0.00561339 156.086 -4.03192e-05C156.08 -0.00569403 156.017 0.282645 155.939 0.633175C155.652 2.0466 155.272 2.80985 154.66 3.23671C154.155 3.58724 153.551 3.80208 152.496 4.01975C152.137 4.09325 151.847 4.15826 151.853 4.16392C151.858 4.16957 152.14 4.22893 152.47 4.29395C153.787 4.57664 154.459 4.85932 154.942 5.32858C155.425 5.79784 155.698 6.49325 155.953 7.75402C156.071 8.38724 156.066 8.3731 156.097 8.22328Z",
    fill: "url(#paint1_linear_3427_243)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M41.1432 1.92224H32.907L28.5389 16.3081L24.0702 1.92224H17.0898L20.5527 12.9328L24.6708 27.5675H32.2547L41.1432 1.92224Z",
    fill: "#682A7A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M28.5389 16.3053L24.0616 1.91943H17.0898L20.5527 12.9442L24.6708 27.576H32.2547L28.5389 16.3053Z",
    fill: "#682A7A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M0 1.72998L8.83968 27.3752H16.4207L20.5905 12.7434L24.1051 1.72998H17.1247L12.6043 16.1158L8.23619 1.72998H0Z",
    fill: "#682A7A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M12.4636 19.6833L12.1877 19.6014L5.52344 17.6932L8.83975 27.3752H16.4207L18.1479 21.3201L12.4636 19.6833Z",
    fill: "url(#paint2_linear_3427_243)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M23.335 22.8156L24.6713 27.5675H32.2551L32.9419 25.5887L23.335 22.8156Z",
    fill: "url(#paint3_linear_3427_243)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3427_243",
    x1: 156.761,
    y1: 11.0699,
    x2: 170,
    y2: 11.0699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68297B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#622E7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#513E8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#35579B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B61A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3427_243",
    x1: 151.838,
    y1: 4.15261,
    x2: 160.293,
    y2: 4.15261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68297B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#622E7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#513E8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#35579B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B61A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3427_243",
    x1: 6.35233,
    y1: 22.9791,
    x2: 18.5071,
    y2: 21.7392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3427_243",
    x1: 23.9426,
    y1: 25.5613,
    x2: 33.1915,
    y2: 24.6178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3427_243"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 170,
    height: 28,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinalWwFulllogo);
export default __webpack_public_path__ + "static/media/Final - WW Full logo.ddf722354aed786d85f22d5194aace06.svg";
export { ForwardRef as ReactComponent };